import { Box, Link } from '@mui/material';
import { forwardRef } from 'react';

interface LogoProps {
  sx: any;
}

const Logo = forwardRef(({ sx }: LogoProps, ref: any) => {
  return (
    <Link href="/" underline="none">
      <Box component="img" ref={ref} src="/logo/logo.png" sx={{ width: 150 }} {...sx} />
    </Link>
  );
});

export default Logo;
